// Sugalarm — /api/analytics wrappers (cycle 6 backend, cycle 10 UI).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  DailySummaryResponse,
  GlucoseSummary,
} from "../lib/types";

export function summary(hours = 24): Promise<ApiResult<GlucoseSummary>> {
  return request<GlucoseSummary>(`/api/analytics/summary?hours=${hours}`);
}

export function summaryRange(
  startIso: string,
  endIso: string,
): Promise<ApiResult<GlucoseSummary>> {
  const q = new URLSearchParams({ start: startIso, end: endIso }).toString();
  return request<GlucoseSummary>(`/api/analytics/summary/range?${q}`);
}

export function daily(days = 14): Promise<ApiResult<DailySummaryResponse>> {
  return request<DailySummaryResponse>(`/api/analytics/daily?days=${days}`);
}
